import {createFileRoute, useParams} from "@tanstack/react-router";

import {routeMessages} from "../../../../../../messages/routes.messages";

import {LeadNotesPage} from "./-page/lead-notes.page";
import {LeadNotesPending} from "./-page/lead-notes.pending";
import {leadNotesSearchSchema} from "./-types";

export const Route = createFileRoute("/_app/sales/leads/$leadId/notes/")({
  component: RouteComponent,
  pendingComponent: LeadNotesPending,
  staticData: {meta: {labelDescriptor: routeMessages.notes}},
  validateSearch: (search) => leadNotesSearchSchema.parse(search),
});

function RouteComponent() {
  const {leadId} = useParams({strict: false}) as {leadId: string};
  const {includeDeleted} = Route.useSearch();

  return <LeadNotesPage includeDeleted={includeDeleted} leadId={leadId} />;
}
